import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-texting-number-deletion-scheduled-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './texting-number-deletion-scheduled.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TextingNumberDeletionScheduledTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TextingNumberDeletionScheduledTemplateData>;
}

export type TextingNumberDeletionScheduledTemplateData = {
  title: string;
  p1_html: string;
  p2_html: string;
  p3_html: string;
  button_link: string;
  button_text: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TextingNumberDeletionScheduledTemplateMocks: TextingNumberDeletionScheduledTemplateData[] =
  [
    {
      title: 'Your company phone number is scheduled to be deleted in 1 month',
      p1_html:
        'After your <b>texting</b> subscription expires, the phone number will be automatically deleted after 6 months. If you want to keep your number, activate the subscription before the deletion date.',
      p2_html: '<b>Scheduled deletion date</b>: 23 Sep 2022',
      p3_html: '<b>Company</b>: {Company name}',
      button_text: 'Activate texting subscription',
      button_link: 'https://app.s.recruitee.com/#/settings/texting',
      footer: {
        text: 'Need help?',
        label: 'Contact us',
        href: 'https://auth.recruitee.com/?intercom_open=true',
        target: '_blank',
      },
    },
  ];
